import React from 'react'
import Helmet from 'react-helmet'
import { Link, graphql } from 'gatsby'
import Layout from '../../layouts/index';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import HtmlParser from 'html-react-parser';
import SEO from '../../components/SEO';
const _ = require('lodash');
const title = "Video"

class categoryRoute extends React.Component {

  render() {
    const posts = this.props.data.allMarkdownRemark.nodes

    const postLinks = posts.map(post => {
      if (post.frontmatter.displayHub) {
        return (
          <div className="blogCards" key={post.frontmatter.path}>
            <a target="_blank" href={post.frontmatter.path}  >
              <div>
                <img src={post.frontmatter.thumbnail} alt={post.frontmatter.title} />
              </div>
              <div className="sectionSpacing">
                <p></p>
                <p>{post.frontmatter.title}</p>
                <p>{post.frontmatter.description}</p>
              </div>
            </a>
          </div>
        )
      }
    })


    return (
      <Layout>
        <SEO title={`${title} | ChartHop`} />
        <Helmet>
          <meta property="og:url" content={`https://www.charthop.com/video`} />
          <meta property="og:title" content={`${title} | ChartHop`} />
          <meta property="og:description" content={`Check out our product videos and recent webinars.`} />
          <meta property="og:image" content={`https://www.charthop.com/home/meta-home.gif`} />
          <meta property="og:type" content="website" />
          <meta property="og:locale" content="en_US" />
          <meta property="og:site_name" content="ChartHop" />
          {/* Twitter Card tags */}
          <meta name="twitter:title" content={`${title} | ChartHop`} />
          <meta name="twitter:description" content={`Check out our product videos and recent webinars.`} />
          <meta name="twitter:image" content={`https://www.charthop.com/home/meta-home.gif`} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@charthop" />
          <meta name="twitter:creator" content="@charthop" />
        </Helmet>

        {/* LATEST POSTS */}
        {/*<section className="sectionSpacing">
          <section className="d-flex flex-column contentBlock">
            <div>
              <p className="blogTaxonomy text-center"><Link className="categoryLink" to="/blog/" >Blog</Link></p>
              <h1 className="text-center">{`category`}</h1>
              <p className="text-center compressedTitle mx-auto header-p mb-0">{categorie_desc}</p>
            </div>
          </section>
        </section>*/}

        {/* LATEST POSTS */}
        <section className="sectionSpacing">
          <section className="d-flex flex-column contentBlock">
            <div>
              <h1 className="text-center">Videos</h1>
              <p className="text-center compressedTitle mx-auto header-p mb-0">Check out our product videos and recent webinars.</p>
            </div>
          </section>
        </section>

        {/* POST CONTENT */}
        <section className="sectionSpacing backgroundGradientContainer-Reverse">
          <div className="blogCardWrapper">
            {postLinks}
          </div>

          <div id="myDIV" className="d-flex sectionSpacing  pb-0 justify-content-center pagination"></div>
        </section>

        {/* LONG FORM */}
        <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
          <DemoFormLong source={title} headertext={HtmlParser("<h1>See it in action!</br></br> Request a demo now.</h1>")} focusID={HtmlParser("name")} />
        </section>

      </Layout >
    )
  }
}

export default categoryRoute

export const query = graphql`
{
  allMarkdownRemark(filter: {frontmatter: {path: {regex: "/^/resources/video/"}}}, sort: {fields: frontmatter___date, order: DESC}) {
    nodes {
      frontmatter {
        path
        title
        thumbnail
        description
        displayHub
      }
    }
  }
}
`;
